module.exports = __webpack_public_path__ + "img/lyndon-b.-johnson.e57c460e.png";